import {
  TextField,
  DateField,
  WrapperField,
  EditButton,
  SearchInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  downloadCSV,
} from 'react-admin';
import jsonExport from 'jsonexport/dist';
import { CraftDateInput } from 'src/components/CraftDateInput';
import { CraftList } from 'src/components/CraftList';
import { usePermissions } from 'src/hooks';
import DeleteButton from './DeleteButton';

const ListFilters = [
  <SearchInput key="search" source="name,key" placeholder="Search" alwaysOn />,
  <CraftDateInput key="createdAtFrom" label="Newer than" source="created_at@_gte" disallowFuture alwaysOn />,
  <CraftDateInput key="createdAtTo" label="Older than" source="created_at@_lte" alwaysOn />,
];

const Actions = ({ canCreate }: { canCreate: boolean }) => (
  <TopToolbar>
    <ExportButton />
    {canCreate && <CreateButton />}
  </TopToolbar>
);

const PortalProgramsList = () => {
  const { permissions } = usePermissions();
  const canEdit = permissions.has('organization:edit');
  const canDelete = permissions.has('programs:delete');

  const exporter = (records: Array<Record<string, unknown>>) => {
    const data = records.map((r) => ({
      name: r.name,
      key: r.key,
      created_at: r.created_at,
      updated_at: r.updated_at,
    }));
    return jsonExport(
      data,
      { headers: ['name', 'key', 'created_at', 'updated_at'] },
      (err: Error | null, csv: string) => {
        if (err) return;
        downloadCSV(csv, 'programs');
      },
    );
  };

  return (
    <CraftList
      title="Programs"
      filters={ListFilters}
      actions={<Actions canCreate={canEdit} />}
      sort={{ field: 'created_at', order: 'DESC' }}
      filter={{ 'deleted_at@_is_null': true }}
      exporter={exporter}
      dataGridProps={{ bulkActionButtons: false }}
    >
      <TextField source="name" />
      <TextField source="key" />
      <DateField source="created_at" showTime />
      {canEdit && (
        <WrapperField label="Actions" headerClassName="column-actions" cellClassName="column-actions">
          {canEdit && <EditButton />}
          {canDelete && <DeleteButton />}
        </WrapperField>
      )}
    </CraftList>
  );
};

export default PortalProgramsList;
